import { render, staticRenderFns } from "./CreateKnivesModal.vue?vue&type=template&id=ed92fc32&scoped=true"
import script from "./CreateKnivesModal.vue?vue&type=script&lang=js"
export * from "./CreateKnivesModal.vue?vue&type=script&lang=js"
import style0 from "./CreateKnivesModal.vue?vue&type=style&index=0&id=ed92fc32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed92fc32",
  null
  
)

export default component.exports